module.exports = __webpack_public_path__ + "static/footer-btn.c6155aca.png";